import React from 'react';

import './Body.css';
// import background3 from "../../assets/images/background1.jpg";

const Body = () => {
  return (
    <div>
      <div className="color-container" style={{marginTop:150}}>
        <div className="container" >
          <div className="section">
            <div className="row">
              <div className="col s12 m4 grow">
                <div className="icon-block">
                  <h2 className="center" style={{color: '#EE4142'}}><i className="material-icons">flash_on</i></h2>
                  <h5 className="center" style={{color: '#373435'}}>We Care</h5>

                  <p className="">Our highly trained and experienced doctors and wellness experts will give you honest medical advice based on NHS International Guidelines.</p>
                </div>
              </div>

              <div className="col s12 m4 grow">
                <div className="icon-block">
                  <h2 className="center" style={{color: '#EE4142'}}><i className="material-icons">group</i></h2>
                  <h5 className="center" style={{color: '#373435'}}>Affordable Care</h5>

                  <p className="">Getting better has never been easy. We will refer you to the specialist, book an appointment on your behalf, deliver medication and lab services to your home or office.</p>
                </div>
              </div>

              <div className="col s12 m4 grow">
                <div className="icon-block">
                  <h2 className="center" style={{color: '#EE4142'}}><i className="material-icons">settings</i></h2>
                  <h5 className="center" style={{color: '#373435'}}>At your own Pace</h5>

                  <p className="">Forget waiting long hours to see a doctor. With Xtendliving, you can speak to our doctors over the phone through our mobile application.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container grow">
        <h3 className="center " style={{color: '#373435'}}>Welcome to Xtendliving!</h3>
      </div>

      <div className="container">
        <div className="section">
          <div className="row">
            <div className="col s12 m6 grow">
              <h3><i className="mdi-content-send brown-text"></i></h3>
              <h5 className="" style={{color: '#373435'}}>Communicating with a doctor has never been easier</h5>
              <p className="left ">Xtendliving, the first Nigerian Population Health Management provider combines next-generation telemedicine, telemonitoring and home health to provide immediate access to highly trained and experienced doctors and wellness experts via voice/ video calls, live chat as well as on-site doctor visits and clinics for healthy, acute and chronic condition management.</p>
            </div>
            <div className="col s12 m6">
                <iframe className="bodyVideo" title="d" src="https://www.youtube.com/embed/_HEnohs6yYw" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <h3 className="center black-text">Services</h3>
      </div>

      {/*<div className="container">
        <div className="section">
          <div className="row">
            <div className="col s12 m4">
              <h3><i className="mdi-content-send brown-text"></i></h3>
              <h6 className="black-text">Integrated Mobile Application</h6>
              <p className="left ">With Xtendliving, you can have xtended access to quality care from anywhere in the world, either at your home, office, on a business trip or vacation through our integrated and interactive mobile application </p>
            </div>
            <div className="col s12 m4">
              <h3><i className="mdi-content-send brown-text"></i></h3>
              <h6 className="black-text">Doctors Control Center</h6>
              <p className="left ">Our Control Center is stuffed with highly trained and experienced doctors and wellness experts who will give you reliable medical and wellness advice based on Evidence Based Medicine. Our doctors can help you manage your condition</p>
            </div>
            <div className="col s12 m4">
              <h3><i className="mdi-content-send brown-text"></i></h3>
              <h6 className="black-text">On site virtual clinic booth</h6>
              <p className="left ">With Xtendliving's virtual clinic, you can take your readings using easy-to-use, integrated smart devices. Your readings will sync with our systems, where our doctors are available, monitoring your readings.</p>
            </div>
          </div>
        </div>
      </div>*/}
        <div className="color-container">
          <div className="container">
            <div className="row">
              <div className="col s12 m4 grow" >
                <h3><i className="mdi-content-send brown-text"></i></h3>
                <h6 className="black-text" style={{fontWeight: 'bold'}}>Integrated Mobile Application</h6>
                <p className="left black-text">With Xtendliving, you can have xtended access to quality care from anywhere in the world, either at your home, office, on a business trip or vacation through our integrated and interactive mobile application </p>
              </div>
              <div className="col s12 m4 grow" >
                <h3><i className="mdi-content-send brown-text"></i></h3>
                <h6 className="black-text" style={{fontWeight: 'bold'}}>Doctors Control Center</h6>
                <p className="left black-text">Our Control Center is stuffed with highly trained and experienced doctors and wellness experts who will give you reliable medical and wellness advice based on Evidence Based Medicine. Our doctors can help you manage your condition</p>
              </div>
              <div className="col s12 m4 grow" >
                <h3><i className="mdi-content-send brown-text"></i></h3>
                <h6 className="black-text" style={{fontWeight: 'bold'}}>On site virtual clinic booth</h6>
                <p className="left black-text">With Xtendliving's virtual clinic, you can take your readings using easy-to-use, integrated smart devices. Your readings will sync with our systems, where our doctors are available, monitoring your readings.</p>
              </div>

              <div className="col s12 m4 grow" >
                <h3><i className="mdi-content-send brown-text"></i></h3>
                <h6 className="black-text" style={{fontWeight: 'bold'}}>Hospital at Home Program</h6>
                <p className="left black-text">Xtendliving's Hospital at Home Program, allows patients to be monitored and treated in the comfort of their homes and/or offices while saving approximately 50 percent of cost.</p>
              </div>
              <div className="col s12 m4 grow">
                <h3><i className="mdi-content-send brown-text"></i></h3>
                <h6 className="black-text" style={{fontWeight: 'bold'}}>Wellness Program</h6>
                <p className="left black-text">According to an article published by Forbes, 87% of workers worldwide are emotionally disconnected from their workplace and less likely to be productive. Not only that, but stress in the workplace is costing employers.</p>
              </div>
              <div className="col s12 m4 grow">
                <h3><i className="mdi-content-send brown-text"></i></h3>
                <h6 className="black-text" style={{fontWeight: 'bold'}}>Healthcare Analytics</h6>
                <p className="left black-text">Xtendliving's healthcare analytics is undertaken as a result of actual claims and cost of data, pharmaceutical data, clinical data(collected from internal EMR), and patient behaviour reported accurately with detailed outcomes.</p>
              </div>
            </div>
          </div>
        </div>


    </div>
  )
}

export default Body;